import {DataTableColumn} from "mantine-datatable";
import {UsageRecord} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {Text} from "@mantine/core";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<UsageRecord>[] = [
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: UsageRecord) => <Text c="blue" style={{cursor: 'pointer'}}>{formatTimestamp(item.created as string)}</Text>,
        },
        {
            accessor: 'username',
            title: I18n.get('User'),
            width: '1fr',
            render: (item: UsageRecord) => item.user?.name || item.username,
        },
        {
            accessor: 'action',
            title: I18n.get('Action'),
            width: '1fr',
            render: (item: UsageRecord) => item.action,
        },
        {
            accessor: 'usageType',
            title: I18n.get('UsageType'),
            width: '1fr',
            render: (item: UsageRecord) => item.usageType,
        },

    ];

    return {
        columns,
    }
}
